<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<mat-tab-group (selectedTabChange)="selectedTabValue($event)" #tabGroup>
  <mat-tab *ngFor="let stage of taskStagesList; let index = index" [label]="stage.stageName" class="tab-title">
    <ng-template mat-tab-label>
      <h4>
        {{ stage.stageName }}
        <span *ngIf="stage.taskStageUsersList != undefined">({{ stage.taskStageUsersList.length }})</span>
      </h4>

    </ng-template>
    <div>
      <div class="d-flex justify-content-between align-items-center my-4">
        <div matTooltip="Collaborative" class="d-flex gap-2 align-items-center stageClass reviewer_any">
          <span>
            <span *ngIf="stage.isOverriden">
              <span *ngIf="getAesthetic(stage)">
                <img src="../../../assets/img/cr_module/reviewer_edit.svg" width="16px" height="16px" alt="edit"
                  (click)="editStageFunc(stage)" (keydown.enter)="editStageFunc(stage)" />
              </span>
            </span>
          </span>
          <h4>{{ stage.anyOrAll | titlecase }}<span *ngIf="stage.noIfAny">-{{ stage.noIfAny }}</span></h4>
        </div>
        <div class="action-buttons-container d-flex gap-2">
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            [matTooltip]=" 'Add ' + (stage.stageName === 'Review' ? 'Reviewer': stage.stageName === 'PhaseII Review' ? 'PhaseII Reviewer': stage.stageName === 'PhaseIII Review' ? 'PhaseIII Reviewer'  : stage.stageName === 'Approve' ? 'Approver': stage.stageName === 'PhaseII Approve' ? 'PhaseII Approver' : stage.stageName === 'PhaseIII Approve' ? 'PhaseIII Approver' : stage.stageName === 'Closure Review' ? 'Closure Reviewer': stage.stageName === 'Closure Approve' ? 'Closure Approver' : stage.stageName)"
            (click)="addStageUserFunc(stage)" (keydown.enter)="addStageUserFunc(stage)" *ngIf="getAesthetic(stage)">
            <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
            <span class="reload_text text-white">Add New</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Excel')" (keydown.enter)="openReport('Excel')">
            <i class="fa fa-file-excel-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Excel Report</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            (click)="openReport('Pdf')" (keydown.enter)="openReport('Pdf')">
            <i class="fa fa-file-pdf-o" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">PDF Report</span>
          </div>
          <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
            *ngIf="message.isAuditTrailUser" (click)="openAuditTrail('overAll',0)"
            (keydown.enter)="openAuditTrail('overAll',0)">
            <i class="fa-solid fa-clipboard" style="font-size:18px;color:white"></i>
            <span class="reload_text text-white">Audit Trail</span>
          </div>
          <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center"
            matTooltip="Refresh Grid">
            <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
            <span class="reload_text">Reload</span>
          </div>
        </div>
      </div>
      <!-- <hr> -->
      <div class="table-container">
        <table class="dynamicReviewApprove-table-container">
          <th class="p-1" style="min-width:100px;">Level</th>
          <th class="p-1" style="min-width:100px;"></th>
          <th class="p-1" style="min-width:250px;">Users/Roles</th>
          <th class="p-1" style="min-width:300px;max-width:300px;">Status</th>
          <th class="p-1" style="min-width:200px;"></th>
          <th class="p-1">Actions</th>

          <tr *ngFor="let user of stage['taskStageUsersList'] | searchFilter : searchValue; let idx = index ">
            <td>
              <div class="label-container"
                *ngIf="idx==0? true : stage['taskStageUsersList'][idx].userLevel!=stage['taskStageUsersList'][idx-1].userLevel">
                <div class="addTaskStageCollabrative">Level&nbsp;:&nbsp;{{user.userLevel}}<i class="fa-solid fa-pencil"
                    style="margin-left: 5px;" [matTooltip]="'Collaborative'" (click)="editCollaborativeFunc(user)"
                    (keydown.enter)="editCollaborativeFunc(user)" *ngIf="getAesthetic(stage)"></i>
                </div>
                <div *ngIf="user.anyOrAll!=null">({{user.anyOrAll}}<span
                    *ngIf="user.noIfAny!=null">-{{user.noIfAny}}</span>)</div>
              </div>
            </td>
            <td style="min-width:100px;max-width:100px">
              <div class="userProfile-container">
                <span *ngIf="user == null || user == undefined">
                  <i class="fa-regular fa-circle-user userimg" style="font-size: 33px; cursor:default;"></i>
                </span>
                <span *ngIf="user != null || user != undefined">
                  <span *ngIf="user.userImage">
                    <img class="userimg" alt="user" src="data:image/*;base64,{{user.userImage}}" />
                  </span>

                </span>
              </div>
            </td>
            <td style="min-width:250px;max-width:250px;overflow-wrap: break-word;text-wrap: wrap;">
              <div class="label-container">
                User Name : <span>{{ user.userName }}</span>
              </div>
              <div class="label-container">
                User Role : <span>{{ user.userRole }}</span>
              </div>
            </td>
            <td>
              <div class="label-container">
                Requested On :
                <span>
                  {{ user.requestedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                </span>
              </div>
              <div class="label-container">
                Completed On :
                <span>
                  {{ user.completedOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss')}}
                </span>
              </div>
            </td>
            <td style="min-width:300px;max-width:300px;overflow-wrap: break-word;text-wrap: wrap;">
              <div *ngIf="user.status != null">
                <div class="commonStyle" [ngStyle]="{ color: getStatusColor(user.status) }">
                  Status :
                  <span>{{ user.status }}</span>
                </div>
              </div>
              <div class="label-container">
                Comments :
                <span>{{ user.comments }}</span>
              </div>
              <div class="label-container">
                Reason for Signature :
                <span>{{ user.reasonForSignature }}</span>
              </div>
            </td>
            <td>
              <div *ngIf="user.doc != undefined">
                <div class="download-button-continer btn-align" mat-dialog-actions>
                  <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                    (click)="downloadDocuments(user)">
                    <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download" />
                    <span class="ms-1">View</span>
                  </button>
                </div>
              </div>

              <div class="d-none">
                <label *ngIf="message.showSwitchUser" id="owner-validation" for="email"
                  (click)="openswitchuser('owner', stage, user)"
                  (keydown.enter)="openswitchuser('owner', stage, user)"><a><img title="Switch User"
                      src="..//..//../assets/img/user-switch.png" alt="Switch User" width="25"
                      height="25" /></a></label>
                <i class="fa fa-eye" style="margin-left: 5px" *ngIf="user.isCheckListSkipped == 'N'"
                  [matTooltip]="'View ' + (stage.stageName === 'Review' ? 'Reviewer': stage.stageName === 'PhaseII Review' ? 'PhaseII Reviewer': stage.stageName === 'PhaseIII Review' ? 'PhaseIII Reviewer'  : stage.stageName === 'Approve' ? 'Approver': stage.stageName === 'PhaseII Approve' ? 'PhaseII Approver' : stage.stageName === 'PhaseIII Approve' ? 'PhaseIII Approver' : stage.stageName === 'Closure Review' ? 'Closure Reviewer' : stage.stageName === 'Closure Approve' ? 'Closure Approver' : stage.stageName) + ' CheckList'"
                  (click)="openCheckListPopup(stage, user)" (keydown.enter)="openCheckListPopup(stage, user)">vvvvv</i>
                <i class="fa-solid fa-pencil" style="margin-left: 5px" *ngIf="getAesthetic(stage)"
                  [matTooltip]="'Edit ' + (stage.stageName === 'Review' ? 'Reviewer': stage.stageName === 'PhaseII Review' ? 'PhaseII Reviewer': stage.stageName === 'PhaseIII Review' ? 'PhaseIII Reviewer'  : stage.stageName === 'Approve' ? 'Approver': stage.stageName === 'PhaseII Approve' ? 'PhaseII Approver' : stage.stageName === 'PhaseIII Approve' ? 'PhaseIII Approver' : stage.stageName === 'Closure Review' ? 'Closure Reviewer' : stage.stageName === 'Closure Approve' ? 'Closure Approver' : stage.stageName)"
                  (click)="editStageUserFunc(stage, user)" (keydown.enter)="editStageUserFunc(stage, user)"></i>
                <i class="fa-sharp fa-solid fa-trash" style="margin-left: 5px" *ngIf="getAesthetic(stage)"
                  [matTooltip]="'Delete ' + (stage.stageName === 'Review' ? 'Reviewer': stage.stageName === 'PhaseII Review' ? 'PhaseII Reviewer': stage.stageName === 'PhaseIII Review' ? 'PhaseIII Reviewer'  : stage.stageName === 'Approve' ? 'Approver': stage.stageName === 'PhaseII Approve' ? 'PhaseII Approver' : stage.stageName === 'PhaseIII Approve' ? 'PhaseIII Approver' : stage.stageName === 'Closure Review' ? 'Closure Reviewer' : stage.stageName === 'Closure Approve' ? 'Closure Approver' : stage.stageName)"
                  (click)="deleteStageUserFunc(stage, user)" (keydown.enter)="deleteStageUserFunc(stage, user)"></i>
              </div>

              <div class="dropdown actions_dropdown">
                <span *ngIf="getAesthetic(stage)">
                  <i [matTooltip]=" 'Edit ' + (stage.stageName === 'Review' ? 'Reviewer': stage.stageName === 'PhaseII Review' ? 'PhaseII Reviewer': stage.stageName === 'PhaseIII Review' ? 'PhaseIII Reviewer'  : stage.stageName === 'Approve' ? 'Approver': stage.stageName === 'PhaseII Approve' ? 'PhaseII Approver' : stage.stageName === 'PhaseIII Approve' ? 'PhaseIII Approver' : stage.stageName === 'Closure Review' ? 'Closure Reviewer' : stage.stageName === 'Closure Approve' ? 'Closure Approver' : stage.stageName) "
                    (click)="editStageUserFunc(stage, user)" (keydown.enter)="editStageUserFunc(stage, user)"
                    style="margin-left: 8px;">
                    <a>
                      <img src="../../../assets/img/cr_module/Edit.svg" alt="edit" width="18px" height="18px" />
                    </a>
                  </i>

                  <i [matTooltip]=" 'Delete ' + (stage.stageName === 'Review' ? 'Reviewer': stage.stageName === 'PhaseII Review' ? 'PhaseII Reviewer': stage.stageName === 'PhaseIII Review' ? 'PhaseIII Reviewer': stage.stageName === 'Approve' ? 'Approver': stage.stageName === 'PhaseII Approve' ? 'PhaseII Approver' : stage.stageName === 'PhaseIII Approve' ? 'PhaseIII Approver' : stage.stageName === 'Closure Review' ? 'Closure Reviewer' : stage.stageName === 'Closure Approve' ? 'Closure Approver' : stage.stageName)  "
                    (click)="deleteStageUserFunc(stage, user)" (keydown.enter)="deleteStageUserFunc(stage, user)"
                    style="margin-left: 5px;">
                    <a>
                      <img src="../../../assets/img/cr_module/delete.svg" width="18px" height="18px" alt="delete" />
                    </a>
                  </i>
                </span>

                <i [matTooltip]="'Switch User'" (click)="openswitchuser('owner', stage, user)"
                  (keydown.enter)="openswitchuser('owner', stage, user)" style="margin-left: 5px;"
                  *ngIf="message.showSwitchUser">
                  <a>
                    <img src="../../../assets/img/cr_module/userSwitch.svg" alt="Switch User" width="18px"
                      height="18px">
                  </a>
                </i>
                <i class="fa fa-eye" style="margin-left: 5px" *ngIf="user.isCheckListSkipped == 'N'"
                  [matTooltip]="'View ' + (stage.stageName === 'Review' ? 'Reviewer': stage.stageName === 'PhaseII Review' ? 'PhaseII Reviewer': stage.stageName === 'PhaseIII Review' ? 'PhaseIII Reviewer'  : stage.stageName === 'Approve' ? 'Approver': stage.stageName === 'PhaseII Approve' ? 'PhaseII Approver' : stage.stageName === 'PhaseIII Approve' ? 'PhaseIII Approver' : stage.stageName === 'Closure Review' ? 'Closure Reviewer' : stage.stageName === 'Closure Approve' ? 'Closure Approver' : stage.stageName) + ' CheckList'"
                  (click)="openCheckListPopup(stage, user)" (keydown.enter)="openCheckListPopup(stage, user)"></i>

                <i matTooltip="Audit Trail" *ngIf="message.isAuditTrailUser" style="margin-left: 5px;"
                  (click)="openAuditTrail('individual',user)" (keydown.enter)="openAuditTrail('individual',user)">
                  <i class="fa-solid fa-clipboard" style="font-size: 18px;color: #005C8A;"></i>
                </i>
              </div>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </mat-tab>
</mat-tab-group>

<ng-template #addOrEditStageUserPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditStageUserFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{title}}</label>
    </div>
    <div id="filed-container" class="form-continer">
      <div class="row">
        <div class="col-md-3"><label for="userRole">User Role</label></div>
        <div class="col-md-9" *ngIf="!isShowUserRoleSingle">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedUserRole" (closed)="userRoleTxt=''"
            (click)="focusmethod('userRoleSearch')" (keydown.enter)="focusmethod('userRoleSearch')"
            [ngClass]="{'odd-item-mat-select':isUserRoleOdd==selectedUserRole}">
            <input type="search" id="userRoleSearch" class="dropdownsearchstyle" [(ngModel)]="userRoleTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onUserRoleRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of userRoleDropdown| assessmentSearch :userRoleTxt"
              (onSelectionChange)="onUserRoleSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
        <div class="col-md-9" *ngIf="isShowUserRoleSingle">
          <input type="text" class="input-filed-continers" [(ngModel)]="selectedUserRoleValue" disabled>
        </div>
      </div>
      <div class="row">

        <div class="col-md-3">
          <label for="user" [ngClass]="{'error-highlight': showError && !selectedUser}">User</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedUser" (closed)="userTxt=''"
            (click)="focusmethod('userTxtSearch')" (keydown.enter)="focusmethod('userTxtSearch')"
            [ngClass]="{'odd-item-mat-select': isUserOdd == selectedUser, 'error-border': showError && !selectedUser}">
            <input type="search" id="userTxtSearch" class="dropdownsearchstyle" [(ngModel)]="userTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onUserRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of userDropdown | assessmentSearch : userTxt"
              (onSelectionChange)="onUserSelect($event, item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

      </div>
      <div class="row">
        <div class="col-md-3">
          <label for="level" [ngClass]="{'error-highlight': showError && !selectedLevel}">Level</label>
          <span class="mandatory-symbol">*</span>
        </div>
        <div class="col-md-9" *ngIf="!isShowLevelSingle">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedLevel" (closed)="userLevelTxt=''"
            (click)="focusmethod('userLevelSearch')" (keydown.enter)="focusmethod('userLevelSearch')"
            [ngClass]="{'error-border': showError && !selectedLevel}">
            <input type="search" id="userLevelSearch" class="dropdownsearchstyle" [(ngModel)]="userLevelTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onLevelRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of levelDropdown | assessmentSearch : userLevelTxt"
              (onSelectionChange)="onLevelSelect($event, item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>

        <div class="col-md-9" *ngIf="isShowLevelSingle">
          <input type="text" class="input-filed-continers" [(ngModel)]="selectedLevelValue" disabled>
        </div>
      </div>

    </div>
  </div>
  <br>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditStageUserFunction(stageUserData)"
      *ngIf="visibleAddButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="addButton" (click)="addAndEditStageUserFunction(stageUserData)"
      *ngIf="visibleEditButton">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditStageUserFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #editStagePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle">Collaborative</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-3"><label for="anyOrAll ">Any or All</label></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" id="noIfAny" [(ngModel)]="selectedAnyOrAll"
            (closed)="anyOrAllTxt=''" (click)="focusmethod('anyOrAllSearch')"
            (keydown.enter)="focusmethod('anyOrAllSearch')">
            <input type="search" id="anyOrAllSearch" class="dropdownsearchstyle" [(ngModel)]="anyOrAllTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onAnyOrAllRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of anyOrAllDropdown| assessmentSearch :anyOrAllTxt"
              (onSelectionChange)="onAnyOrAllSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row" *ngIf="selectedAnyOrAllValue !='ALL'">
        <div class="col-md-3"><label for="noIfAny">No. If Any</label></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedNoIfAny" (closed)="noIfAnyTxt=''"
            (click)="focusmethod('noIfAnySearch')" (keydown.enter)="focusmethod('noIfAnySearch')">
            <input type="search" id="noIfAnySearch" class="dropdownsearchstyle" [(ngModel)]="noIfAnyTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onNoIfAnyRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of noIfAnyDropdown| assessmentSearch :noIfAnyTxt"
              (onSelectionChange)="onNoIfAnySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditFunction(stageData)">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #editCollaborativePopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditCollaborativeFunction()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">Level-{{stageData.userLevel}}&nbsp;Collaborative</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="form-continer">
      <div class="row">
        <div class="col-md-3"><label for="anyOrAll ">Any or All</label></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedAnyOrAll" (closed)="anyOrAllTxt=''"
            (click)="focusmethod('anyOrAllSearch1')" (keydown.enter)="focusmethod('anyOrAllSearch1')">
            <input type="search" id="1" class="dropdownsearchstyle" [(ngModel)]="anyOrAllTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onAnyOrAllRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of anyOrAllDropdown| assessmentSearch :anyOrAllTxt"
              (onSelectionChange)="onAnyOrAllSelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
      <div class="row" *ngIf="selectedAnyOrAllValue !='ALL'">
        <div class="col-md-3"><label for="noIfAny">No. If Any</label></div>
        <div class="col-md-9">
          <mat-select matInput placeholder="Select" [(ngModel)]="selectedNoIfAny" (closed)="noIfAnyTxt=''"
            (click)="focusmethod('noIfAnySearch1')" (keydown.enter)="focusmethod('noIfAnySearch1')">
            <input type="search" id="noIfAnySearch1" class="dropdownsearchstyle" [(ngModel)]="noIfAnyTxt" matInput
              placeholder="search">
            <mat-option class="unselectStyle" (onSelectionChange)="onNoIfAnyRemoved(null)"
              [value]="null">Un-select</mat-option>
            <mat-option *ngFor="let item of noIfAnyDropdown| assessmentSearch :noIfAnyTxt"
              (onSelectionChange)="onNoIfAnySelect($event,item)" [value]="item.valueExp">
              {{ item.displayExp }}
            </mat-option>
          </mat-select>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="addAndEditCollaborativeFunction(stageData)">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditCollaborativeFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deleteStageUserPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>

  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{title}}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div class="form-continer">
      <div class="row">
        <div class="col-md-12">
          <div><label id="deleteReason-validation" for="deleteReason"> Reason</label><span
              class="mandatory-symbol">*</span></div>
          <textarea id="deleteTextarea" rows="6" class="textarea-filed-continers" type="text"
            [(ngModel)]="stageUserData.deleteReason" (focusout)="onFieldFocusout()"></textarea>
        </div>
      </div>
      <br>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #checkListPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelCheckListPopup()" mat-button>
      <i style="font-size: 23px;color: white;" class="fa">&#xf00d;</i>
    </button>

    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ checkListTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div *ngIf="!isProcessing" style="margin: 10px;">
      <div class="form-continer" style="max-height: 550px !important;">
        <div *ngIf="checkListFields.length && !isProcessing">
          <ng-container *ngFor="let field of checkListFields; let i = index;">
            <div class="row" style="margin-top: 1px;">
              <div class="col-md-4">
                <label id="category-name" for="email">{{ i + 1 }}.&nbsp;{{ field.fieldName }}</label>
              </div>

              <div class="col-md-4">
                <div>
                  <label id="analytical-lab-investigation" for="email">
                    Response
                  </label>
                  <span class="mandatory-symbol">*</span>
                </div>
                <ng-container [ngSwitch]="field.fieldTypeCode">
                  <!-- Text Field -->
                  <input *ngSwitchCase="'Text Field'" class="form-control" [(ngModel)]="field.response"
                    [disabled]="true">

                  <!-- Date Field -->
                  <input *ngSwitchCase="'Date Field'" type="text" class="form-control data-picker-continer" bsDatepicker
                    [bsConfig]="commonDateConfig" [dateCustomClasses]="dateCustomClasses" [(ngModel)]="field.response"
                    [disabled]="true">

                  <!-- Large Text -->
                  <textarea *ngSwitchCase="'Large Text'" class="form-control" rows="4" [(ngModel)]="field.response"
                    [disabled]="true"></textarea>

                  <!-- Drop Down -->
                  <mat-select *ngSwitchCase="'Drop Down'" [(ngModel)]="field.response" placeholder="Select"
                    (closed)="dropDownSearchText=''" (click)="focusSearch('search')" [disabled]="true"
                    (keydown.enter)="focusSearch('search')">
                    <input matInput type="search" [(ngModel)]="dropDownSearchText" class="dropdownsearchstyle"
                      placeholder="Search">
                    <mat-option class="unselectStyle" [value]="null">Un-select</mat-option>
                    <mat-option *ngFor="let item of field.fieldValues | assessmentSearch : dropDownSearchText"
                      [value]="item">{{ item }}</mat-option>
                  </mat-select>

                  <!-- Multiselect Drop Down -->
                  <mat-select *ngSwitchCase="'Multiselect Drop Down'" multiple #multiselect [(ngModel)]="field.dd"
                    placeholder="Select" (closed)="dropDownSearchText=''" (click)="focusSearch('multi-search')"
                    [disabled]="true" (keydown.enter)="focusSearch('multi-search')">
                    <input matInput type="multi-search" [(ngModel)]="dropDownSearchText" placeholder="Search"
                      class="dropdownsearchstyle">
                    <div class="select-all">
                      <mat-checkbox [(ngModel)]="multiSelection">Select All</mat-checkbox>
                    </div>
                    <mat-option *ngFor="let q of field.fieldValues | assessmentSearch : dropDownSearchText" [value]="q">
                      {{ q }}
                    </mat-option>
                  </mat-select>

                  <!-- Vertical Radio Button -->
                  <mat-radio-group *ngSwitchCase="'Vertical Radio Button'" [(ngModel)]="field.response"
                    class="d-flex flex-column" matTooltipPosition="below">
                    <mat-radio-button *ngFor="let val of field.fieldValues" [value]="val" [disabled]="true">
                      {{ val }}
                    </mat-radio-button>
                  </mat-radio-group>

                  <!-- Horizontal Radio Button -->
                  <mat-radio-group *ngSwitchCase="'Horizontal Radio Button'" [(ngModel)]="field.response"
                    class="d-inline-flex" matTooltipPosition="below">
                    <mat-radio-button *ngFor="let val of field.fieldValues" [value]="val" [disabled]="true">
                      {{ val }}
                    </mat-radio-button>
                  </mat-radio-group>

                  <!-- Vertical Checkbox Button -->
                  <ng-container *ngSwitchCase="'Vertical Checkbox Button'">
                    <section *ngFor="let val of field.fieldValues" class="d-flex flex-column">
                      <mat-checkbox [checked]=" field.dd.indexOf(val) !=-1" [disabled]="true">
                        {{ val }}
                      </mat-checkbox>
                    </section>
                  </ng-container>

                  <!-- Horizontal Checkbox Button -->
                  <ng-container *ngSwitchCase="'Horizontal Checkbox Button'" style="align-items: center;">
                    <section *ngFor="let val of field.fieldValues" class="d-inline-flex">
                      <mat-checkbox [checked]="field.dd.indexOf(val) != -1" [disabled]="true">
                        {{ val }}
                      </mat-checkbox>
                    </section>
                  </ng-container>
                </ng-container>
              </div>

              <div class="col-md-4">
                <div>
                  <label id="justification" for="email">
                    Justification
                  </label>
                  <span class="mandatory-symbol">*</span>
                </div>
                <textarea class="input-filed-textarea" rows="4" [(ngModel)]="field.justification"
                  [disabled]="true"></textarea>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
      <div class="d-flex justify-content-center gap-3 mx-3 button-continer" mat-dialog-actions>
        <button mat-stroked-button class="cancelButton" (click)="cancelCheckListPopup()">
          <i class="fa fa-close"></i> Cancel
        </button>
      </div>
    </div>
  </div>
</ng-template>

<app-switchuser #switchUserPopup1 (valueEmitter)="onChildValueEmitted()"></app-switchuser>
<app-static-audit-trail #auditTrailPopup></app-static-audit-trail>
<app-excel-pdf #excelPdfPopup [excelPdf]="excelPdf"></app-excel-pdf>
<app-document-viewer #viewPopup [docViewer]="docViewer" *ngIf="docViewer?.doc"></app-document-viewer>